import { Box, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useColors from "../../../../../api/hooks/useColors";

const AssetBusinessValue = ({
  formData,
  setFormData,
  showHelperText = true,
}) => {
  const colors = useColors();
  const [value, setValue] = useState("");
  const handleChange = (event) => {
    const value = event.target.value;

    if ((value !== undefined && value === "") || /^\d*$/.test(value)) {
      setFormData((prevData) => ({
        ...prevData,
        stepAssetDetails: {
          asset: {
            ...prevData.stepAssetDetails.asset,
            businessValue: value,
          },
        },
      }));
    }
  };

  useEffect(() => {
    setValue(formData.stepAssetDetails.asset.businessValue);
  }, [formData.stepAssetDetails.asset.businessValue]);

  return (
    <TextField
      fullWidth
      label={
        <Box display={"flex"} flexDirection={"row"} gap={1}>
          <Typography variant="body2" color={colors.text_secondary}>
            Estimated business value ($)
          </Typography>
          <span style={{ color: colors.error_main }}>*</span>
        </Box>
      }
      type="text"
      value={value}
      onChange={handleChange}
      placeholder="e.g. 1000000"
      helperText={
        showHelperText
          ? "Enter only digits. Estimate the financial impact of a breach involving this asset. You can customize this to match your business context."
          : ""
      }
      sx={{
        "& .MuiOutlinedInput-notchedOutline": {
          borderRadius: "8px",
          borderColor: colors.divider2,
        },
        "& .MuiOutlinedInput-root": {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "0.5px solid " + colors.divider2,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "0.5px solid " + colors.grey_500,
          },
        },

        "& .MuiInputBase-input::placeholder": {
          color: colors.text_primary,
        },
        width: "100%",
        "& .MuiInputBase-root": { height: "52px" },
      }}
    />
  );
};

export default AssetBusinessValue;
